export function isLightRoute(url?: string): boolean {
  if (url) {
    return url.includes('/light');
  }
  return window.location.pathname.includes('/light');
}

export function getLightTokenFromUrl(): string | null {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get('t');
}
